import { createStore } from 'ice';
import user from './models/user';
import permission from './models/permission';
import calender from './models/calender';
import home from './models/home';
import dict from './models/dict';

const store = createStore({ user, permission, calender, home, dict });

export default store;
